module.exports = __webpack_public_path__ + "img/qrcode-weixin.484e1785.png";